// extracted by mini-css-extract-plugin
export default {"root":"CountDown_root__-EI3W","overtime":"CountDown_overtime__eN-uO"};